import { getMimeTypeFromFile } from 'src/app/core/common';
import CryptoJS from 'crypto-js';
import { StiBookFileResponse } from './sti.models';

export function decryptStiBookBuffer(encryptedBuffer: ArrayBuffer, fileInfo: StiBookFileResponse): ArrayBuffer {
    if (fileInfo.cipher.toLowerCase() !== 'aes-256-cbc') throw new Error(`Unsupported cipher: ${fileInfo.cipher}`);

    const key = CryptoJS.enc.Utf8.parse(fileInfo.key);
    const iv = CryptoJS.enc.Utf8.parse(fileInfo.iv);

    if (key.sigBytes !== 32) throw new Error(`Invalid AES-256 key length: expected 32 bytes, received ${key.sigBytes}.`);
    if (iv.sigBytes !== 16) throw new Error(`Invalid AES-CBC IV length: expected 16 bytes, received ${iv.sigBytes}.`);

    const cipherParams = CryptoJS.lib.CipherParams.create({
        ciphertext: CryptoJS.enc.Hex.parse(arrayBufferToHex(encryptedBuffer)),
    });

    const decrypted = CryptoJS.AES.decrypt(cipherParams, key, {
        iv,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
    });

    return hexToArrayBuffer(decrypted.toString(CryptoJS.enc.Hex));
}

export function createStiBookFile(decryptedBuffer: ArrayBuffer, fileName: string): File {
    const mimeType = getMimeTypeFromFile(fileName.toLowerCase());
    const blob = new Blob([decryptedBuffer], { type: mimeType });
    return new File([blob], fileName, { type: blob.type });
}

function arrayBufferToHex(buffer: ArrayBuffer): string {
    return Array.from(new Uint8Array(buffer))
        .map((byte) => byte.toString(16).padStart(2, '0'))
        .join('');
}

function hexToArrayBuffer(hex: string): ArrayBuffer {
    const bytes = new Uint8Array(hex.length / 2);
    for (let i = 0; i < hex.length; i += 2) {
        bytes[i / 2] = parseInt(hex.slice(i, i + 2), 16);
    }

    return bytes.buffer;
}
